<div class="qrwrap">
  <div class="d-flex justify-content-center header">
    <img src="../../../../assets/image/bankId.svg" class="logo" />
    <h5 class="title">{{ dataContext.statusText }}</h5>
  </div>
  @if (dataContext.qrCode) {
    <div class="d-flex justify-content-center">
      @if (dataContext.qrCode) {
        <qrcode [qrdata]="dataContext.qrCode" [width]="185" [errorCorrectionLevel]="'M'"></qrcode>
      }
    </div>
  }
  <div class="d-flex">
    <button class="btn ml-auto" type="button" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
  </div>
</div>
